import React, { useState } from "react";
import "./NewProduct.css";

import Img1 from "./Assets/Group 1171275322.png";
import Img2 from "./Assets/Group 1171275323.png";
import Img3 from "./Assets/Group 1171275324.png";
import StarIcon from "./Assets/Text Ellipse.png";

export default function Products() {
  const [active, setActive] = useState(1);

  const items = [
    {
      id: 1,
      number: "01",
      title: "Decision making, redefined with Meta stockpicker",
      desc: `Meta stockpicker lets you skip endless tables and spot stock patterns instantly. 
      It delivers real-time, visual insights for smarter, faster, data-backed decisions with ease.`,
      image: Img1,
      link: "https://metastockpicker.com/",
    },
    {
      id: 2,
      number: "02",
      title: "Daily Astrology Reimagined with Myluckydays",
      desc: `My Lucky Days (MLD) uses AR to bring the stars alive, combining ancient Vedic 
      wisdom with real-time forecasts, emotional tracking, and helping you flow with the universe.`,
      image: Img2,
      link: "https://play.google.com/store/apps/details?id=tech.kushmanda.luckydays&hl=en_IN",
    },
    {
      id: 3,
      number: "03",
      title: "Wiki Bedtime stories - where stories meet serenity",
      desc: `Wiki Bedtime Stories blends timeless wisdom with modern wellbeing, offering calming 
      stories that support restful sleep for kids of all ages.`,
      image: Img3,
      link: "https://wikibedtimestories.com",
    },
  ];

  return (
    <section className="products-section">
      <h1 className="main-heading">Explore our products</h1>

      {/* ---- TABS ---- */}
      <div className="tabs-wrapper">
        <div className="tabs-row">
          {items.map((item) => (
            <div
              key={item.id}
              className={`tab-number ${active === item.id ? "active" : ""}`}
              onClick={() => setActive(item.id)}
            >
              {item.number}
            </div>
          ))}
        </div>

        <div className="tabs-full-line"></div>

        <div
          className="tabs-active-line"
          style={{ left: `${(active - 1) * 33.33}%` }}
        ></div>
      </div>

      {/* ---- CONTENT ---- */}
      <div className="content-wrapper">
        <div className="left-box">
          <div className="title-with-icon">
            <h2
              className="product-title clickable-title"
              onClick={() => window.open(items[active - 1].link, "_blank")}
            >
              {items[active - 1].title}
              <img src={StarIcon} alt="open" className="title-icon" />
            </h2>
          </div>


          <p className="product-desc">{items[active - 1].desc}</p>
        </div>

        <div className="right-box">
          <img src={items[active - 1].image} alt="product" />
        </div>
      </div>
    </section>
  );
}
